/*
function Example() {
    // typically the selector used to initalize the plugin is the widget itself
    // perhaps if there was significant padding on the widget, an ancestor element may be used
    const element = $(".widget-promos");

    // designers typically don't want the animation kicked off exactly as the element enters the view and waiting until halfway is too long
    // kick off the animations when the element is 75% from the top of the screen
    const offset = 75;

    // multiple objects within the element can be animated in different ways
    // optionally animations from groups of objects can be staggered
    const targets = [
        { selector: ".rich-text", type: "animate__fadeInRight", stagger: 0 },
        { selector: ".shared-promo-card", type: "animate__fadeInUp", stagger: 400 }
    ]

    // designs for many components lately have elements that are meant to overflow out of the component
    // fadeInRight (and maybe others causes a horizontal scroll bar that no one wants to see
    // one solution is to optionally set overflow to hidden while the animation is occurring
    const overflow = true;

    element.ZagScrollAnimate({
        // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
        offset: offset,
        targets: targets,
        overflow: overflow
    });
}
*/

(function ($) {

    $.ZagScrollAnimate = function (element, options) {

        var component = element;
        var options = $.extend({}, $.ZagScrollAnimate.defaultOptions, options);
        ZagScrollAnimateSetup(component, options);

    };

    $.fn.ZagScrollAnimate = (function (options) {
        return this.each(function () {
            (new $.ZagScrollAnimate($(this), options));
        });
    });

    $.ZagScrollAnimate.defaultOptions = { offset: 50, targets: [], overflow: false };

    ZagScrollAnimateSetup = function (component, options) {

        options.targets.forEach((target) => {
            count = 0;
            component.find(target.selector).each(function () {
                $(this).attr("data-scroll_animate_type", target.type);
                $(this).attr("data-scroll_animate_stagger", count * target.stagger);
                count++;
            });
        });

        var waypoint = new Waypoint({
            element: component,
            handler: function (direction) {
                ZagScrollAnimateExecute(this.element, direction, options.overflow);
            },
            triggerOnce: true,
            offset: options.offset + '%'
        })
    };

    ZagScrollAnimateExecute = function (waypoint, direction, overflow) {
        if (direction == "down") {

            if (overflow) {
                ZagScrollAnimateOverflow(waypoint);
            }

            waypoint.find("[data-scroll_animate_type]").each(function () {
                var element = $(this);
                var type = $(this).attr("data-scroll_animate_type");
                var stagger = $(this).attr("data-scroll_animate_stagger");

                setTimeout(
                    function (e) {
                        element.addClass("animate__animated");
                        element.addClass(type);
                    }, stagger);

            });
        }
    };

    ZagScrollAnimateOverflow = function (waypoint) {

        // 1000 ms comes from the animate.css's 1 second animation standard
        const animationDuration = 1000;
        const elementsLast = waypoint.find("[data-scroll_animate_type]").last();
        const elementsLastStagger = parseInt(elementsLast.attr("data-scroll_animate_stagger")) + animationDuration;

        waypoint.addClass("zag-scroll-animate-hide-overflow");

        setTimeout(
            function (e) {
                waypoint.removeClass("zag-scroll-animate-hide-overflow");
            }, elementsLastStagger);

    }

})(jQuery);